import { IconContent } from '@icons';

export const book: IconContent = {
    md: '<path fill-rule="evenodd" d="M6.5 3.5a2 2 0 0 0-2 2V18A2.5 2.5 0 0 0 7 20.5h12v-14H6.5a1 1 0 0 1 0-2H19v-1H6.5Zm-1 3.732V18A1.5 1.5 0 0 0 7 19.5h11v-12H6.5a1.99 1.99 0 0 1-1-.268ZM8 9.5h8v1H8v-1Zm8 2.5H8v1h8v-1Z" />',
};
